import { ROUTES } from '@router'

export function getSEOTranslationKeys({
  route = {},
  translations = {},
  pageTitle = '',
  rate,
  count,
} = {}) {
  let title
  let description
  let params = {
    rate,
    count,
  }

  switch (route.name) {
    case ROUTES.REVIEWS.PAGES.PRODUCT: {
      title = translations.SEOTitleProduct
      description = translations.SEODescriptionProduct
      params = { ...params, productName: route.query?.productName }
      break
    }
    case ROUTES.REVIEWS.PAGES.MERCHANT: {
      title = translations.SEOTitleMerchantProducts
      description = translations.SEODescriptionMerchantProducts
      params = { ...params, merchantName: pageTitle }
      break
    }
    case ROUTES.REVIEWS.PAGES.LANDING: {
      title = translations.SEOTitleListingProduct
      description = translations.SEODescriptionListingProduct
      params = { ...params, productName: pageTitle }
      break
    }
    case ROUTES.REVIEWS.PAGES.ALL:
    default:
      title = translations.SEOTitleAllProducts
      description = translations.SEODescriptionAllProducts
  }

  return {
    title: {
      key: title,
      params,
    },
    description: {
      key: description,
      params,
    },
  }
}
